
// import React, { useEffect, useState } from "react";
// import axiosAuth from "../api/axiosAuth";
// import "../style/DirectorGrupoProfesor.css";

// export default function DirectorGrupoProfesor() {
//   const [loading, setLoading] = useState(true);

//   const [director, setDirector] = useState(null);
//   const [estudiantes, setEstudiantes] = useState([]);
//   const [asistencias, setAsistencias] = useState([]);

//   const [periodos, setPeriodos] = useState([]);
//   const [periodoSeleccionado, setPeriodoSeleccionado] = useState("");
//   const [notas, setNotas] = useState([]);

//   const [vistaActiva, setVistaActiva] = useState("general");

//   useEffect(() => {
//     cargarInformacion();
//   }, []);

//   const cargarInformacion = async () => {
//     try {
//       setLoading(true);

//       const permisosRes = await axiosAuth.get("/directores-grupo/mis-permisos");

//       // 🔥 NORMALIZAR PERMISOS (CLAVE PARA QUE NO FALLEN)
//       const permisos = {
//         es_director: false,
//         puede_notas: 0,
//         puede_asistencia: 0,
//         puede_observador: 0,
//         puede_convivencia: 0,
//         puede_financiero: 0,
//         puede_certificados: 0,
//         ...permisosRes.data,
//       };

//       setDirector(permisos);

//       if (permisos.es_director) {
//         const estudiantesRes = await axiosAuth.get("/directores-grupo/mis-estudiantes");
//         setEstudiantes(estudiantesRes.data || []);

//         try {
//           const asistenciasRes = await axiosAuth.get("/directores-grupo/mis-asistencias");
//           setAsistencias(asistenciasRes.data || []);
//         } catch (err) {
//           console.log("⚠️ Endpoint mis-asistencias aún no existe");
//         }
//       }

//       const periodosRes = await axiosAuth.get("/directores-grupo/mis-periodos");
//       setPeriodos(periodosRes.data || []);

//       if (periodosRes.data?.length) {
//         const primerPeriodo = periodosRes.data[0].id;
//         setPeriodoSeleccionado(primerPeriodo);

//         const notasRes = await axiosAuth.get(
//           `/directores-grupo/consolidado-notas?periodo_id=${primerPeriodo}`
//         );

//         setNotas(notasRes.data || []);
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Error cargando información del director de grupo");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const cargarNotas = async (periodo_id) => {
//     try {
//       setPeriodoSeleccionado(periodo_id);

//       const res = await axiosAuth.get(
//         `/directores-grupo/consolidado-notas?periodo_id=${periodo_id}`
//       );

//       setNotas(res.data || []);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const presentes = asistencias.filter(a => a.estado?.toLowerCase() === "presente").length;
//   const ausentes = asistencias.filter(a => a.estado?.toLowerCase() === "ausente").length;
//   const tardanzas = asistencias.filter(a => a.estado?.toLowerCase() === "tarde").length;

//   if (loading) {
//     return (
//       <div className="director-profesor-container">
//         <h2>Cargando...</h2>
//       </div>
//     );
//   }

//   if (!director?.es_director) {
//     return (
//       <div className="director-profesor-container">
//         <div className="director-profesor-card">
//           <h2>👨‍🏫 Director de Grupo</h2>
//           <div className="sin-directoria">
//             No tiene dirección de grupo asignada.
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="director-profesor-container">

//       {/* ================= CABECERA ================= */}
//       <div className="director-profesor-card">
//         <h2>👨‍🏫 Director de Grupo</h2>

//         <div className="director-info">
//           <div>
//             <strong>Grado:</strong> {director.grado}° {director.grupo}
//           </div>
//           <div>
//             <strong>Estudiantes:</strong> {estudiantes.length}
//           </div>
//         </div>
//       </div>

//       {/* ================= DASHBOARD ================= */}
//       <div className="director-profesor-card">
//         <h3>📊 Resumen General</h3>

//         <div className="director-dashboard">
//           <div className="dashboard-box">
//             <h4>{estudiantes.length}</h4>
//             <span>Estudiantes</span>
//           </div>

//           <div className="dashboard-box">
//             <h4>{presentes}</h4>
//             <span>Presentes</span>
//           </div>

//           <div className="dashboard-box">
//             <h4>{ausentes}</h4>
//             <span>Ausentes</span>
//           </div>

//           <div className="dashboard-box">
//             <h4>{tardanzas}</h4>
//             <span>Tardanzas</span>
//           </div>
//         </div>
//       </div>

//       {/* ================= MENÚ ================= */}
//       <div className="director-profesor-card">
//         <h3>Módulos</h3>

//         <div className="director-menu">

//           {Number(director.puede_notas) === 1 && (
//             <button
//               className="menu-btn"
//               onClick={() =>
//                 setVistaActiva(vistaActiva === "notas" ? "general" : "notas")
//               }
//             >
//               📚 Notas
//             </button>
//           )}

//           {Number(director.puede_asistencia) === 1 && (
//             <button
//               className="menu-btn"
//               onClick={() =>
//                 setVistaActiva(vistaActiva === "asistencia" ? "general" : "asistencia")
//               }
//             >
//               📅 Asistencia
//             </button>
//           )}

//           {Number(director.puede_observador) === 1 && (
//             <button className="menu-btn">
//               📝 Observador
//             </button>
//           )}

//           {Number(director.puede_convivencia) === 1 && (
//             <button className="menu-btn">
//               ⚖️ Convivencia
//             </button>
//           )}

//           {Number(director.puede_financiero) === 1 && (
//             <button className="menu-btn">
//               💰 Financiero
//             </button>
//           )}

//           {Number(director.puede_certificados) === 1 && (
//             <button className="menu-btn">
//               📄 Certificados
//             </button>
//           )}

//         </div>
//       </div>

//       {/* ================= ESTUDIANTES ================= */}
//       <div className="director-profesor-card">
//         <h3>👨‍🎓 Estudiantes</h3>

//         <table className="director-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Documento</th>
//               <th>Nombre</th>
//               <th>Grado</th>
//               <th>Grupo</th>
//             </tr>
//           </thead>

//           <tbody>
//             {estudiantes.map((e, i) => (
//               <tr key={e.id}>
//                 <td>{i + 1}</td>
//                 <td>{e.documento_estudiante}</td>
//                 <td>{e.nombres_estudiante} {e.apellidos_estudiante}</td>
//                 <td>{e.grado}</td>
//                 <td>{e.grupo}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* ================= ASISTENCIA ================= */}
//       {vistaActiva === "asistencia" && (
//         <div className="director-profesor-card">
//           <h3>📅 Asistencia</h3>

//           <table className="director-table">
//             <thead>
//               <tr>
//                 <th>Fecha</th>
//                 <th>Documento</th>
//                 <th>Estudiante</th>
//                 <th>Estado</th>
//               </tr>
//             </thead>

//             <tbody>
//               {asistencias.map(a => (
//                 <tr key={a.id}>
//                   <td>{a.fecha ? new Date(a.fecha).toLocaleDateString() : "-"}</td>
//                   <td>{a.documento_estudiante}</td>
//                   <td>{a.nombres_estudiante} {a.apellidos_estudiante}</td>
//                   <td>{a.estado}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* ================= NOTAS ================= */}
//       {vistaActiva === "notas" && (
//         <div className="director-profesor-card">
//           <h3>📚 Notas</h3>

//           <select
//             value={periodoSeleccionado}
//             onChange={(e) => cargarNotas(e.target.value)}
//             className="form-select"
//           >
//             {periodos.map(p => (
//               <option key={p.id} value={p.id}>
//                 {p.nombre}
//               </option>
//             ))}
//           </select>

//           <table className="director-table">
//             <thead>
//               <tr>
//                 <th>Documento</th>
//                 <th>Estudiante</th>
//                 <th>Materia</th>
//                 <th>Nota</th>
//                 <th>Desempeño</th>
//               </tr>
//             </thead>

//             <tbody>
//               {notas.map((n, i) => (
//                 <tr key={i}>
//                   <td>{n.documento_estudiante}</td>
//                   <td>{n.nombres_estudiante} {n.apellidos_estudiante}</td>
//                   <td>{n.materia}</td>
//                   <td>{n.nota}</td>
//                   <td>{n.desempeno}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//     </div>
//   );
// }


//
import React, { useEffect, useState } from "react";
import axiosAuth from "../api/axiosAuth";
import "../style/DirectorGrupoProfesor.css";

export default function DirectorGrupoProfesor() {
  const [loading, setLoading] = useState(true);

  const [director, setDirector] = useState(null);
  const [estudiantes, setEstudiantes] = useState([]);
  const [asistencias, setAsistencias] = useState([]);

  const [periodos, setPeriodos] = useState([]);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState("");
  const [notas, setNotas] = useState([]);

  // 🆕 OBSERVACIONES
  const [observaciones, setObservaciones] = useState([]);

  const [vistaActiva, setVistaActiva] = useState("general");

  useEffect(() => {
    cargarInformacion();
  }, []);

  const cargarInformacion = async () => {
    try {
      setLoading(true);

      const permisosRes = await axiosAuth.get("/directores-grupo/mis-permisos");

      const permisos = {
        es_director: false,
        puede_notas: 0,
        puede_asistencia: 0,
        puede_observador: 0,
        puede_convivencia: 0,
        puede_financiero: 0,
        puede_certificados: 0,
        ...permisosRes.data,
      };

      setDirector(permisos);

      if (permisos.es_director) {
        const estudiantesRes = await axiosAuth.get("/directores-grupo/mis-estudiantes");
        setEstudiantes(estudiantesRes.data || []);

        try {
          const asistenciasRes = await axiosAuth.get("/directores-grupo/mis-asistencias");
          setAsistencias(asistenciasRes.data || []);
        } catch (err) {
          console.log("⚠️ asistencias no disponible");
        }

        // 🆕 OBSERVACIONES (INICIAL)
        if (permisos.puede_observador == 1) {
          cargarObservaciones();
        }
      }

      const periodosRes = await axiosAuth.get("/directores-grupo/mis-periodos");
      setPeriodos(periodosRes.data || []);

      if (periodosRes.data?.length) {
  const primerPeriodo = periodosRes.data[0].id;

  setPeriodoSeleccionado(primerPeriodo);

  const notasRes = await axiosAuth.get(
    `/directores-grupo/consolidado-notas?periodo_id=${primerPeriodo}`
  );

  setNotas(notasRes.data || []);

  if (
    permisos.es_director &&
    Number(permisos.puede_observador) === 1
  ) {
    await cargarObservaciones(primerPeriodo);
  }
}

    } catch (error) {
      console.error(error);
      alert("Error cargando información del director de grupo");
    } finally {
      setLoading(false);
    }
  };

  const cargarNotas = async (periodo_id) => {
    try {
      setPeriodoSeleccionado(periodo_id);

      const res = await axiosAuth.get(
        `/directores-grupo/consolidado-notas?periodo_id=${periodo_id}`
      );

      setNotas(res.data || []);
    } catch (error) {
      console.error(error);
    }
  };
  const cambiarPeriodoObservaciones = async (periodo_id) => {
  try {
    setPeriodoSeleccionado(periodo_id);

    await cargarObservaciones(periodo_id);
  } catch (error) {
    console.error(error);
  }
};

  // 🆕 OBSERVACIONES REAL (BACKEND)
const cargarObservaciones = async (periodo_id = periodoSeleccionado) => {
  try {
    if (!periodo_id) return;

    const res = await axiosAuth.get(
      `/directores-grupo/observaciones?periodo_id=${periodo_id}`
    );

    console.log("OBSERVACIONES:", res.data);

    setObservaciones(res.data || []);
  } catch (error) {
    console.error("Error observaciones:", error);
  }
};

  const presentes = asistencias.filter(a => a.estado?.toLowerCase() === "presente").length;
  const ausentes = asistencias.filter(a => a.estado?.toLowerCase() === "ausente").length;
  const tardanzas = asistencias.filter(a => a.estado?.toLowerCase() === "tarde").length;

  if (loading) {
    return (
      <div className="director-profesor-container">
        <h2>Cargando...</h2>
      </div>
    );
  }

  if (!director?.es_director) {
    return (
      <div className="director-profesor-container">
        <div className="director-profesor-card">
          <h2>👨‍🏫 Director de Grupo</h2>
          <div className="sin-directoria">
            No tiene dirección de grupo asignada.
          </div>
        </div>
      </div>
    );
  }

  const estudiantesConNotas = Object.values(
  notas.reduce((acc, item) => {

    const id = item.documento_estudiante;

    if (!acc[id]) {
      acc[id] = {
        documento: item.documento_estudiante,
        estudiante:
          `${item.nombres_estudiante} ${item.apellidos_estudiante}`,
        notas: {}
      };
    }

    acc[id].notas[item.materia] = item.nota;

    return acc;

  }, {})
);

const materias = [
  ...new Set(
    notas.map((n) => n.materia)
  )
];
  return (
    <div className="director-profesor-container">

      {/* CABECERA */}
      <div className="director-profesor-card">
        <h2>👨‍🏫 Director de Grupo</h2>
        <div className="director-info">
          <div><strong>Grado:</strong> {director.grado}° {director.grupo}</div>
          <div><strong>Estudiantes:</strong> {estudiantes.length}</div>
        </div>
      </div>

      {/* DASHBOARD */}
      <div className="director-profesor-card">
        <h3>📊 Resumen General</h3>

        <div className="director-dashboard">
          <div className="dashboard-box"><h4>{estudiantes.length}</h4><span>Estudiantes</span></div>
          <div className="dashboard-box"><h4>{presentes}</h4><span>Presentes</span></div>
          <div className="dashboard-box"><h4>{ausentes}</h4><span>Ausentes</span></div>
          <div className="dashboard-box"><h4>{tardanzas}</h4><span>Tardanzas</span></div>
        </div>
      </div>

      {/* MENÚ */}
      <div className="director-profesor-card">
        <h3>Módulos</h3>

        <div className="director-menu">

          {Number(director.puede_notas) === 1 && (
            <button className="menu-btn" onClick={() => setVistaActiva("notas")}>
              📚 Notas
            </button>
          )}

          {Number(director.puede_asistencia) === 1 && (
            <button className="menu-btn" onClick={() => setVistaActiva("asistencia")}>
              📅 Asistencia
            </button>
          )}

          {Number(director.puede_observador) === 1 && (
            <button className="menu-btn" onClick={() => {
              setVistaActiva("observador");
              cargarObservaciones();
            }}>
              📝 Observador
            </button>
          )}

        </div>
      </div>

      {/* ESTUDIANTES */}
      <div className="director-profesor-card">
        <h3>👨‍🎓 Estudiantes</h3>

        <table className="director-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Documento</th>
              <th>Nombre</th>
              <th>Grado</th>
              <th>Grupo</th>
            </tr>
          </thead>
          <tbody>
            {estudiantes.map((e, i) => (
              <tr key={e.id}>
                <td>{i + 1}</td>
                <td>{e.documento_estudiante}</td>
                <td>{e.nombres_estudiante} {e.apellidos_estudiante}</td>
                <td>{e.grado}</td>
                <td>{e.grupo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ASISTENCIA */}
      {vistaActiva === "asistencia" && (
        <div className="director-profesor-card">
          <h3>📅 Asistencia</h3>

          <table className="director-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Documento</th>
                <th>Estudiante</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {asistencias.map(a => (
                <tr key={a.id}>
                  <td>{a.fecha ? new Date(a.fecha).toLocaleDateString() : "-"}</td>
                  <td>{a.documento_estudiante}</td>
                  <td>{a.nombres_estudiante} {a.apellidos_estudiante}</td>
                  <td>{a.estado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* NOTAS */}
   {/* ================= NOTAS CONSOLIDADAS ================= */}
{vistaActiva === "notas" && (
  <div className="director-profesor-card">

    <h3>📚 Consolidado Académico</h3>

    <div className="director-filtros">

      <select
        value={periodoSeleccionado}
        onChange={(e) => cargarNotas(e.target.value)}
        className="form-select"
      >
        {periodos.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nombre}
          </option>
        ))}
      </select>

    </div>

    <div className="director-table-responsive">

      <table className="director-table">

        <thead>

          <tr>

            <th>Documento</th>

            <th
              style={{
                minWidth: "250px"
              }}
            >
              Estudiante
            </th>

            {materias.map((materia) => (
              <th key={materia}>
                {materia}
              </th>
            ))}

            <th>Promedio</th>

          </tr>

        </thead>

        <tbody>

          {estudiantesConNotas.length === 0 && (
            <tr>
              <td colSpan={materias.length + 3}>
                No hay notas registradas para este período
              </td>
            </tr>
          )}

          {estudiantesConNotas.map((estudiante) => {

            const listaNotas = Object.values(
              estudiante.notas
            );

            const promedio =
              listaNotas.length > 0
                ? (
                    listaNotas.reduce(
                      (a, b) => a + Number(b),
                      0
                    ) / listaNotas.length
                  ).toFixed(1)
                : "-";

            return (
              <tr key={estudiante.documento}>

                <td>
                  {estudiante.documento}
                </td>

                <td>
                  {estudiante.estudiante}
                </td>

                {materias.map((materia) => (
                  <td key={materia}>
                    {estudiante.notas[materia] ?? "-"}
                  </td>
                ))}

                <td>
                  <strong>
                    {promedio}
                  </strong>
                </td>

              </tr>
            );
          })}

        </tbody>

      </table>

    </div>

  </div>
)}

      {/* 🆕 OBSERVADOR REAL */}
     {/* 🆕 OBSERVADOR REAL */}
{vistaActiva === "observador" && (
  <div className="director-profesor-card">

    <h3>📝 Observador del Grupo</h3>

    <div style={{ marginBottom: "15px" }}>
      <select
        value={periodoSeleccionado}
        onChange={(e) =>
          cambiarPeriodoObservaciones(e.target.value)
        }
        className="form-select"
      >
        {periodos.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nombre}
          </option>
        ))}
      </select>
    </div>

    <table className="director-table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Estudiante</th>
          <th>Tipo</th>
          <th>Observación</th>
          <th>Estado</th>
        </tr>
      </thead>

      <tbody>

        {observaciones.length === 0 && (
          <tr>
            <td colSpan="5">
              No hay observaciones registradas para este período
            </td>
          </tr>
        )}

        {observaciones.map((o) => (
          <tr key={o.id}>
            <td>
              {o.fecha
                ? new Date(o.fecha).toLocaleDateString()
                : "-"}
            </td>

            <td>
              {o.nombres_estudiante} {o.apellidos_estudiante}
            </td>

            <td>{o.tipo}</td>

            <td>{o.observacion}</td>

            <td>{o.estado}</td>
          </tr>
        ))}

      </tbody>
    </table>

  </div>
)}

    </div>
  );
}